import React from 'react';
import styled from 'styled-components';

import { getLuggageText } from './luggageUtils';

import type { LuggageItem } from './types';

export interface FlightsLuggageItemProps {
  luggageArray: LuggageItem[];
  className?: string;
}

const FlightsLuggageItem = ({
  luggageArray,
  className,
}: FlightsLuggageItemProps): JSX.Element => (
  <StyledParagraph>
    {luggageArray.map(([type, luggageParams], i) => (
      <StyledParagraph key={type} className={className}>
        <span>{getLuggageText(luggageParams, type, false)}</span>
        {luggageArray.length - 1 !== i && <span>, </span>}
      </StyledParagraph>
    ))}
  </StyledParagraph>
);

const StyledParagraph = styled.div`
  display: inline;
`;

export default FlightsLuggageItem;
